import Image from '@common/image';
import { ReactionEnum, ReactionType } from '@domain/constant/chat/ReactionType';

interface ReactionProps {
  width: number;
  height: number;
  type: ReactionType;
}

const Reaction = ({ width, height, type }: ReactionProps) => {
  switch (type) {
    case ReactionEnum.thumb:
      return (
        <Image src={'/img/v2/components/chat/iconThumb.png'} alt={'heart'} width={width} height={height} pointer />
      );
    case ReactionEnum.heart:
      return (
        <Image src={'/img/v2/components/chat/iconHeart.png'} alt={'heart'} width={width} height={height} pointer />
      );
    case ReactionEnum.smile:
      return (
        <Image src={'/img/v2/components/chat/iconSmile.png'} alt={'heart'} width={width} height={height} pointer />
      );
    case ReactionEnum.cry:
      return <Image src={'/img/v2/components/chat/iconCry.png'} alt={'heart'} width={width} height={height} pointer />;
    default:
      return null;
  }
};

export default Reaction;
